import { render, staticRenderFns } from "./DataDropdownEditor.vue?vue&type=template&id=cf361964&scoped=true&"
import script from "./DataDropdownEditor.vue?vue&type=script&lang=js&"
export * from "./DataDropdownEditor.vue?vue&type=script&lang=js&"
import style0 from "./DataDropdownEditor.vue?vue&type=style&index=0&id=cf361964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf361964",
  null
  
)

export default component.exports